<route>
{
    "name": "dashboard",
    "meta": {
        "title": "Asistent CRM",
        "requiresAuth": true,
        "permission": "guest",
        "fail": "/404"
    }
}
</route>
<template>
    <main-layout>
        <assistant-dashboard />
    </main-layout>
</template>

<script>
import MainLayout from "Layouts/Main.vue";
import AssistantDashboard from "Components/AssistantDashboard.vue";

export default {
    components: {
        AssistantDashboard,
        MainLayout
    }
};
</script>
